<template>
  <MtxCard class="my-commits mt-3">
    <h4 class="text-center">My Commits</h4>
    <template v-if="commits.length">
      <ul class="list-plain my-4">
        <li v-for="commit of commits" :key="commit.hash" class="my-commits__commit">
          <div class="my-commits__commit-info">
            <RouterLink :to="`/commits/${commit.hash}`">
              {{ commit.hash }}
            </RouterLink>
            <div>
              <small>
                file content:
                <a :href="`https://ipfs.infura.io/ipfs/${commit.ipfsContent}/`" target="_blank">
                  view on IPFS
                </a>
              </small>
            </div>
          </div>
          <div class="mb-2 mb-0@sm">
            {{ (commit.timestamp * 1000) | date("MMM Do, YYYY") }}
          </div>
        </li>
      </ul>

      <div class="text-center">
        <button v-if="hasMore" :disabled="isLoading" @click="getCommits">load more</button>
        <button v-else disabled>no more</button>
      </div>
    </template>

    <div v-else class="text-center">
      <p>You have not created any commits yet.</p>
      <RouterLink to="/commits/create" class="btn">Create One</RouterLink>
    </div>
  </MtxCard>
</template>

<script>
import web3 from "@/mixins/web3"
import API from "@/api"

export default {
  mixins: [web3],

  data: () => ({
    hasMore: false,
    isLoading: false,
    commits: []
  }),

  watch: {
    "$store.state.user.ethAddress": {
      async handler() {
        this.commits = []
        await this.getCommits()
      },
      immediate: true
    }
  },

  methods: {
    async getCommits() {
      this.isLoading = true

      const { data, success } = await API.getCommitsByOwner({
        owner: this.$store.state.user.ethAddress,
        offset: this.commits.length
      })

      if (success) {
        this.commits.push(...data.commits)
        this.hasMore = !!data.commits.length
      }

      this.isLoading = false
    }
  }
}
</script>

<style lang="scss">
.my-commits {
  &__commit {
    @include breakpoint(sm) {
      display: grid;
      grid-gap: rem($size3);
      grid-template-columns: 1fr auto;
    }
  }

  &__commit-info {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: none;
  }
}
</style>
